import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';
import Select from 'react-select'

class EntrepreneurshipDevelopement extends React.Component {
    
    
    
    constructor(props) {
        super(props);
        this.state = {
           
        };
    }

    
    
    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Entrepreneurship Developement</h2>
                            </div>
                        </div>
                    </div>
                </div>


                <section id="trending_causes_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                            <img src="/assets/img/entrepreneurship/business-plan.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>Business Plans</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/business-plans'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                            <img src="/assets/img/entrepreneurship/organization.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>Entity Registrations</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/organization-registrations'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                        <img src="/assets/img/entrepreneurship/legal-schemes.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>Legal Compliances</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/legal-registrations'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                        <img src="/assets/img/entrepreneurship/business-development-schemes.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>Business Development Schemes</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/business-related-schemes'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                        <img src="/assets/img/entrepreneurship/artificial-intelligence.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>AI Business Tools</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/artificial-intelligence'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                                <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                    <div class="case_boxed_img">
                                        <a href="javascript:;">
                                        <img src="/assets/img/entrepreneurship/marketing.jpeg" alt="img"/>
                                        </a>
                                    </div>
                                    <div class="causes_boxed_text">
                                        <h5 style={{'height' : '43px'}}>
                                            <a href="javascript:;" style={{'color' : '#000000'}}>Online Marketing Platforms</a>
                                        </h5>
                                        <Link to={'/entrepreneurship-developement/marketing'}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(EntrepreneurshipDevelopement)